import { render, staticRenderFns } from "./occupancy-and-revenue-chart.vue?vue&type=template&id=64fbbefc&"
import script from "./occupancy-and-revenue-chart.vue?vue&type=script&lang=ts&"
export * from "./occupancy-and-revenue-chart.vue?vue&type=script&lang=ts&"
import style0 from "./occupancy-and-revenue-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
